import { Binary, ClipboardCheck, Eye } from "lucide-react";
import { useDepth } from "./DepthContext";

type DepthBriefProps = {
  summary: string;
  signals: readonly [string, string, string];
  title: string;
};

const depthIcons = {
  overview: Eye,
  operations: ClipboardCheck,
  architecture: Binary,
};

export function DepthBrief({ signals, summary, title }: DepthBriefProps) {
  const { definition, depth } = useDepth();
  const Icon = depthIcons[depth];

  return (
    <aside
      aria-label={`${definition.label} view map`}
      className={`depth-brief depth-brief--${depth}`}
      data-depth={depth}
      data-depth-anchor
      key={depth}
    >
      <div className="depth-brief__intro">
        <span><Icon aria-hidden="true" size={16} /> Active view · {definition.label}</span>
        <strong>{title}</strong>
        <p>{summary}</p>
      </div>
      <div className="depth-brief__map">
        <span>What changed on this page</span>
        <ul>
        {signals.map((signal) => <li key={signal}>{signal}</li>)}
        </ul>
      </div>
    </aside>
  );
}
